import { useState, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';

import { api } from '../lib/api';

interface Lastnosti {
  podjetje: string;
  naziv: string;
}

/**
 * Umik podjetja v arhiv (samo skrbnik).
 *
 * Arhiviranje je obrnljivo: podjetje izgine iz uporabe, podatki pa ostanejo.
 * Dokončni izbris je mogoč samo iz arhiva, kjer je treba vpisati naziv — tako
 * se knjižb in uvozov ne da izgubiti z enim klikom.
 */
export function IzbrisPodjetja({ podjetje, naziv }: Lastnosti): JSX.Element {
  const pojdi = useNavigate();
  const [tece, setTece] = useState(false);
  const [napaka, setNapaka] = useState<string | null>(null);

  const arhiviraj = (): void => {
    setTece(true);
    setNapaka(null);
    api
      .arhivirajPodjetje(podjetje)
      .then(() => {
        pojdi('/arhiv', { replace: true });
      })
      .catch((e: unknown) => {
        setNapaka(e instanceof Error ? e.message : 'Podjetja ni bilo mogoče arhivirati.');
        setTece(false);
      });
  };

  return (
    <section className="kartica nevarno">
      <h2>Arhiviranje podjetja</h2>
      <p className="namig">
        Podjetje <strong>{naziv}</strong> umakne iz uporabe: stranke ga ne vidijo več, podatki
        (knjižbe, uvozi, nastavitve) pa ostanejo. V arhivu ga lahko obnovite ali dokončno
        izbrišete.
      </p>
      {napaka !== null && <p className="napaka">{napaka}</p>}
      <button type="button" className="povezava nevarna" onClick={arhiviraj} disabled={tece}>
        {tece ? 'Arhiviram …' : 'Arhiviraj podjetje'}
      </button>
    </section>
  );
}
